import { TrelloStorage } from '@trello/storage';
import { WEB_SOCKETS_LOCAL_STORAGE_KEY } from './webSockets.constants';

export function webSocketsDeactivated() {
  return TrelloStorage.get(WEB_SOCKETS_LOCAL_STORAGE_KEY) === 'no';
}
